/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContentIssue} from "./contentIssue.zod";
import {EvaluatedCatalogBlock} from "./evaluatedCatalogBlock.zod";
import {EvaluatedOfferChapter} from "./evaluatedOfferChapter.zod";
import {OfferExchangeRates} from "./offerExchangeRates.zod";
import {OfferFinancials} from "./offerFinancials.zod";
import {ResolvedOfferVariable} from "./resolvedOfferVariable.zod";

export const offerEvaluationTwoAgreedCommissionFractionMin = 0;
export const offerEvaluationTwoAgreedCommissionFractionMax = 1;

export const OfferEvaluation = zod
  .unknown()
  .and(
    zod.object({
      exchangeRates: OfferExchangeRates,
      agreedCommissionAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      agreedCommissionFraction: zod
        .number()
        .min(offerEvaluationTwoAgreedCommissionFractionMin)
        .max(offerEvaluationTwoAgreedCommissionFractionMax)
        .optional()
        .describe(
          "Current selected valid agreement rate, unchanged by Chapter exemption. No selected agreement means zero; a missing selected agreement remains unavailable. Nonzero agreement disclosure follows protected Chapters where commission applies, including optional Chapters. Exempt Chapters and zero rates introduce no protected dependency. Availability does not require coefficients.",
        ),
      catalogBlocks: zod.array(EvaluatedCatalogBlock),
      chapters: zod.array(EvaluatedOfferChapter),
      variables: zod.array(ResolvedOfferVariable),
      financials: OfferFinancials,
      issues: zod.array(ContentIssue),
    }),
  )
  .describe(
    "Inputs are returned once under coefficient-free content. Every unissued phase, including OBSOLETE, uses LIVE sources; issued facts remain frozen. Trusted internal commercial calculation and per-field disclosure are distinct: public selling can be AVAILABLE while private costs are RESTRICTED. Coefficients are independently protected. Known source cost does not require completed selling pricing. Optional Chapters remain individually valid\/priced but do not enter ordinary financial aggregates. Snapshot creation uses complete unmasked facts, never this viewer projection. Technical faults are not availability.",
  );

export type OfferEvaluation = zod.input<typeof OfferEvaluation>;
export type OfferEvaluationOutput = zod.output<typeof OfferEvaluation>;
